@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.`init`.InitKobwebContext
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.martdev.flickq.adminkobweb.pages.admin.Dashboard as _com_martdev_flickq_adminkobweb_pages_admin_Dashboard
import com.martdev.flickq.adminkobweb.pages.admin.LoginPage as _com_martdev_flickq_adminkobweb_pages_admin_LoginPage
import com.martdev.flickq.adminkobweb.pages.admin.ReportsPage as _com_martdev_flickq_adminkobweb_pages_admin_ReportsPage
import com.martdev.flickq.adminkobweb.pages.admin.movies.MoviePage as _com_martdev_flickq_adminkobweb_pages_admin_movies_MoviePage
import com.martdev.flickq.adminkobweb.pages.admin.movies.MoviesPage as _com_martdev_flickq_adminkobweb_pages_admin_movies_MoviesPage
import com.martdev.flickq.adminkobweb.pages.admin.reservation.ReservationDetailPage as _com_martdev_flickq_adminkobweb_pages_admin_reservation_ReservationDetailPage
import com.martdev.flickq.adminkobweb.pages.admin.reservation.ReservationsPage as _com_martdev_flickq_adminkobweb_pages_admin_reservation_ReservationsPage
import com.martdev.flickq.adminkobweb.pages.admin.room.RoomDetail as _com_martdev_flickq_adminkobweb_pages_admin_room_RoomDetail
import com.martdev.flickq.adminkobweb.pages.admin.room.RoomPage as _com_martdev_flickq_adminkobweb_pages_admin_room_RoomPage
import com.martdev.flickq.adminkobweb.pages.admin.room.RoomsPage as _com_martdev_flickq_adminkobweb_pages_admin_room_RoomsPage
import com.martdev.flickq.adminkobweb.pages.admin.showtime.ShowtimeListScreen as _com_martdev_flickq_adminkobweb_pages_admin_showtime_ShowtimeListScreen
import com.martdev.flickq.adminkobweb.pages.admin.showtime.ShowtimePage as _com_martdev_flickq_adminkobweb_pages_admin_showtime_ShowtimePage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "FlickQ Admin"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.register(
            "/admin/dashboard",
        ) { pageCtx -> 
            _com_martdev_flickq_adminkobweb_pages_admin_Dashboard()
        }
        ctx.router.register(
            "/admin/login",
        ) { pageCtx -> 
            _com_martdev_flickq_adminkobweb_pages_admin_LoginPage(pageCtx)
        }
        ctx.router.register(
            "/admin/movies/item",
        ) { pageCtx -> 
            _com_martdev_flickq_adminkobweb_pages_admin_movies_MoviePage()
        }
        ctx.router.register(
            "/admin/movies/items",
        ) { pageCtx -> 
            _com_martdev_flickq_adminkobweb_pages_admin_movies_MoviesPage()
        }
        ctx.router.register(
            "/admin/reports",
        ) { pageCtx -> 
            _com_martdev_flickq_adminkobweb_pages_admin_ReportsPage()
        }
        ctx.router.register(
            "/admin/reservation/detail/{id}",
        ) { pageCtx -> 
            _com_martdev_flickq_adminkobweb_pages_admin_reservation_ReservationDetailPage()
        }
        ctx.router.register(
            "/admin/reservation/list",
        ) { pageCtx -> 
            _com_martdev_flickq_adminkobweb_pages_admin_reservation_ReservationsPage()
        }
        ctx.router.register(
            "/admin/room/detail/{id}",
        ) { pageCtx -> 
            _com_martdev_flickq_adminkobweb_pages_admin_room_RoomDetail()
        }
        ctx.router.register(
            "/admin/room/info",
        ) { pageCtx -> 
            _com_martdev_flickq_adminkobweb_pages_admin_room_RoomPage()
        }
        ctx.router.register(
            "/admin/room/list",
        ) { pageCtx -> 
            _com_martdev_flickq_adminkobweb_pages_admin_room_RoomsPage()
        }
        ctx.router.register(
            "/admin/showtime/info",
        ) { pageCtx -> 
            _com_martdev_flickq_adminkobweb_pages_admin_showtime_ShowtimePage()
        }
        ctx.router.register(
            "/admin/showtime/list",
        ) { pageCtx -> 
            _com_martdev_flickq_adminkobweb_pages_admin_showtime_ShowtimeListScreen()
        }

        com.martdev.flickq.adminkobweb.initKobweb(ctx)
    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        com.martdev.flickq.adminkobweb.initSilk(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.martdev.flickq.adminkobweb.AdminApp {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
